/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { CREDIT_CARD_CONSTANTS } from "../../../../utils/data.rest.constants";
import { Merchant } from "../../../../models";
import { MerchantService } from "../../../../services";

@Component({
  selector: "app-accepted-credit-cards-edit",
  templateUrl: "./accepted-credit-cards-edit.component.html"
})
export class AcceptedCreditCardsEditComponent {
  supportedCards = CREDIT_CARD_CONSTANTS.CREDIT_CARDS;
  @Input() parentGroup!: FormGroup;
  @Input() acceptedCards!: FormGroup;
  @Input("merchant") merchant!: Merchant;
  @Input("isEditable") isEditable!: boolean;
  constructor(private merchantService: MerchantService) {}

  isWorldPay(): boolean {
    return this.merchantService.isWorldPay(this.merchant);
  }

  get acceptedCardsFormControl() {
    return this.acceptedCards.controls;
  }
}
